import styled from 'styled-components'
import React, { useCallback } from 'react'
import settings from '../settings'

const FormInformation = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${(p) => p.theme.colors.default};
  background-color: ${(p) => p.theme.forms.formInformation?.backgroundColor};
  padding: 16px 24px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }
  ul {
    padding-left: 15px;
    list-style: none;
  }
  li {
    position: relative;

    &::before {
      content: '•';
      position: absolute;
      left: -0.6em;
      top: -0.4em;
      font-size: 26px;
    }
  }
  a {
    color: ${(p) => p.theme.typography.link.color};
    text-decoration: ${(p) => p.theme.typography.link.textDecoration};
  }
  & > * {
    margin: 0;
  }
`

export const FormExtraInformation = ({ text }) => {
  const onClick = useCallback((e) => {
    if (!e.target.href?.includes('#chat')) {
      return
    }

    e.preventDefault()
    if (
      window.fcWidget?.open &&
      window.fcWidget?.show &&
      settings.brand === 'magnet'
    ) {
      window.fcWidget.open()
      window.fcWidget.show()
    }
  }, [])

  if (!text) {
    return <></>
  }

  return (
    <FormInformation
      onClick={onClick}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  )
}
